import axios from "../../../../../services/api";
import Axios, { AxiosResponse, CancelTokenSource } from "axios";
import { getEnv } from "../../../../../api";
import { PaginationParamProps } from "../../../../hooks";
import { CanaisDigitaisInterface } from "../../../../interfaces";
export interface ICanaisDigitaisService {
  findAll: (
    params: PaginationParamProps,
    body: Record<string, any>,
    source?: CancelTokenSource
  ) => Promise<any>;
  read: (id: string | number) => Promise<any>;
  findUfs: () => Promise<any>;
  create: (body: CanaisDigitaisInterface) => Promise<any>;
  getOptions: (opcoes: boolean) => Promise<any>;
  searchInput: (
    body: Record<string, any>,
    params: PaginationParamProps,
    source?: CancelTokenSource
  ) => Promise<any>;
  update: (body: CanaisDigitaisInterface) => Promise<any>;
  delete: (id: { id: string | number }) => Promise<any>;
}

export const CanaisDigitaisService: ICanaisDigitaisService = {
  findAll: async (params, body = {}, source) => {
    try {
      // @ts-ignore
      const response: AxiosResponse = await axios.post(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/canaisdigitais/consultar`,
        body,
        {
          params,
          cancelToken: source?.token,
        }
      );
      return response.data;
    } catch (error) {
      if (Axios.isCancel(error)) {
        console.log("Requisição cancelada", error.message);
      } else {
        // @ts-ignore
        console.log(error.message);
        throw error;
      }
    }
  },
  read: async (id) => {
    const params = { id };
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/canaisdigitais`,
        { params }
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
  findUfs: async () => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/ufs`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
  create: async (body) => {
    // @ts-ignore
    const response = await axios.post(
      `${await getEnv("REACT_APP_URL_SERVICE")}/v1/canaisdigitais`,
      body
    );
    return response.data;
  },
  update: async (body) => {
    try {
      // @ts-ignore
      return await axios.put(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/canaisdigitais`,
        body
      );
    } catch (error) {
      return error;
    }
  },
  delete: async (id) => {
    const params = { id };
    try {
      // @ts-ignore
      return await axios.delete(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/canaisdigitais`,
        { params }
      );
    } catch (error) {
      return error;
    }
  },
  getOptions: async () => {
    try {
      // @ts-ignore
      const response = await axios.get(
        `${await getEnv("REACT_APP_URL_SERVICE")}/v1/canaisdigitais/opcoes`
      );
      return response.data;
    } catch (error) {
      return error;
    }
  },
  searchInput: async (body, params, source) => {
    // @ts-ignore
    const response = await axios.post(
      `${await getEnv("REACT_APP_URL_SERVICE")}/v1/canaisdigitais/consultar`,
      body,
      {
        params,
        cancelToken: source?.token,
      }
    );
    source?.cancel("Operação cancelada pelo usuário");
    return response.data;
  },
};
